export default __webpack_public_path__ + "static/media/kitchen4-afterB-2048w.e6907d86.webp";